import React from 'react';

import { Box, Typography } from '@mui/material';

import { InstructorCourseCardOnBundleBox } from './style';

import MyAvatar from 'src/components/atoms/Avatar';
import { getAssetUrl } from 'src/helpers/utils';
import { IInstructorsInfo } from 'src/interfaces';
import { IUser } from 'src/interfaces/user';

interface Props {
  instructor: IInstructorsInfo;
}

const InstructorCourseCardOnBundle = ({ instructor }: Props) => (
  <InstructorCourseCardOnBundleBox sx={{ my: instructor ? '7px' : '7.5px' }}>
    <MyAvatar
      className="avatar-instructor"
      errorImage={`${getAssetUrl('thumbnail-instructor.jpg')}`}
      alt={instructor.firstname}
      src={instructor.image_url}
    />
    <Typography className="instructor-info">{`${instructor.firstname} ${instructor.lastname}`}</Typography>
  </InstructorCourseCardOnBundleBox>
);

export default InstructorCourseCardOnBundle;
